import React from 'react';
import { injectIntl } from 'react-intl';
import { getRoundLabel, convertObjectToArray } from '../../lib/ep.js';

import { SecondaryButton } from '../builder/ActionButton.js';
import { useOwner } from '../context/context.js';
import { ProfileModule } from '../ui_items/Module.js';

const PendingMatchesBracketsWarning = (props) => {
	const owner = useOwner();
	
	const promotion = owner?.promotion?.Promotion ?? false;
	if(promotion === false) return null;

	const brackets = props?.brackets ?? false;
	if(brackets === false) return null;

	let pending_brackets = {};
	const pending_matches = brackets.matches.filter((m) => { return m.BracketMatch.status == 0 });
	const closed_stages = brackets.stages.filter((st) => { return EPDateAfter(null, st.Stage.end_date)});

	closed_stages.map((stage) => {
		const total_matches_stage = pending_matches.filter((match) => { return match.BracketMatch.stage_id == stage.Stage.id; }).length;
		if(pending_brackets[stage.Stage.bracket_id] == undefined) pending_brackets[stage.Stage.bracket_id] = { total:0 };
		pending_brackets[stage.Stage.bracket_id]['total'] += total_matches_stage;

		const info_bracket = brackets.brackets.find((b) => { return b.Bracket.id == stage.Stage.bracket_id; });
		if(info_bracket != undefined) pending_brackets[stage.Stage.bracket_id].bracket = info_bracket.Bracket;
	});

	pending_brackets = convertObjectToArray(pending_brackets);

	let brackets_to_display = [];
	pending_brackets.map((b) => {
		if(b.total > 0) brackets_to_display.push(b);
	});

	if(pending_brackets.length == 0 || brackets_to_display.length == 0) return null;

	return (
		<ProfileModule title={{ label:"Matchups pending to be settled", icon:'knk-brackets' }}>
			<ul class="gui_clean_listed_elements">
				{brackets_to_display.map((_bracket, b) => {
					const bracket = _bracket.bracket;
					if(bracket == undefined) return null;

					const current_round = bracket.current_round;
					const link_bracket = `/promotions/builder/${promotion.id}#stages/brackets/${bracket.id}/rounds/${current_round}`;

					const round_label = getRoundLabel(bracket, current_round, false, props.intl);

					return (
						<li key={`pending_bracket_${b}`}>
							<div>
								<p class="knk-arrow-r-big gui_padded_icon gui_small_icon">
									<strong>{bracket.title}</strong><span> ({round_label})</span>
								</p>

								<SecondaryButton
									_href={link_bracket}
									autotranslate={false}
								>{props.intl.formatMessage({id:"Settle {num} matchups"}, { num:_bracket.total })}</SecondaryButton>
							</div>
						</li>
					)
				})}
			</ul>
		</ProfileModule>
	);
}

export default injectIntl(PendingMatchesBracketsWarning);